module.exports = __webpack_public_path__ + "static/img/75路.a9cb69e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/75路.jpg
// module id = 288k
// module chunks = 2